import { QrcodeOutlined } from '@ant-design/icons'
import Modal from 'components/Modal/Modal'
import React from 'react'
import { useDispatch } from 'react-redux'
import { QRCodeSVG } from 'qrcode.react'
import { getQRCode } from 'services/booking.service'

import styles from "./QrGenerator.module.scss"

export default function QrGenerator({ orderId }) {
    const [showQr, setShowQr] = React.useState(false)
    const [qrCode, setQrCode] = React.useState(null)

    const dispatch = useDispatch()


    async function generateQrCode() {
        if (!orderId)
            return


        // generate code for the order
        const response = await dispatch(getQRCode(orderId))
        if (response.data) {
            setQrCode(response.data?.qrCodeToken)
            setShowQr(true)
        }

    }

    return (
        <>
            <div onClick={() => { generateQrCode(orderId) }} className={styles.button}>
                <span style={{ fontSize: 11 }}>Get QR Code</span>
                <QrcodeOutlined style={{ fontSize: 20 }} size={20} />

            </div>
            <Modal
                title="QR Code"
                visible={showQr}
                maskClosable={true}
                onCancel={() => setShowQr(false)}
                footer={[]}
            >
                <p>Scan this QR code in the LMIV Reward App.</p>
                {qrCode && (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <QRCodeSVG value={qrCode} size={220} />
                    </div>
                )}
            </Modal>
        </>
    )
}
